import graphql from "babel-plugin-relay/macro";
import styles from "components/account/details/AccountDetails.module.scss";
import { Message } from "shared/components/Message";
import { accountMessages } from "domain/account/accountMessages";
import { phoneNumberTypes } from "domain/account/models/phoneNumber";
import { AccountReadonlyContactDetails_account } from "generatedQueries/AccountReadonlyContactDetails_account.graphql";
import React, { FC } from "react";
import { createFragmentContainer } from "react-relay";
import { Badge, ListGroup, ListGroupItem } from "reactstrap";

export interface IAccountReadonlyContactDetails {
    account: AccountReadonlyContactDetails_account;
}

const InternalAccountReadonlyContactDetails: FC<IAccountReadonlyContactDetails> = ({
    account,
}) => (
    <section aria-labelledby="contactDetailsHeading">
        <h3 className="sr-only h4" id="contactDetailsHeading"><Message message={accountMessages.contactDetailsLabel} /></h3>
        <dl className={styles.contactDetailsDescriptionList}>
            <dt><Message message={accountMessages.phoneNumbersLabel} /></dt>
            <dd>
                <ListGroup>
                    {
                        account.phoneNumbers?.map(phoneNumber => {
                            const typeLabel = phoneNumberTypes.find(t => t.value === phoneNumber.type);

                            return <ListGroupItem key={phoneNumber.id}>
                                <Message
                                    message={accountMessages.phoneNumberDisplayLabel}
                                    values={{
                                        number: phoneNumber.number,
                                        type: (
                                            <Badge pill={true}>
                                                <span className="sr-only">Type: </span>
                                                <Message message={typeLabel ? typeLabel.label : accountMessages.unknownPhoneNumberTypeLabel} />
                                            </Badge>
                                        ),
                                    }} />
                            </ListGroupItem>;
                        })
                    }
                </ListGroup>
            </dd>
        </dl>
    </section>
);

export const AccountReadonlyContactDetails = createFragmentContainer(InternalAccountReadonlyContactDetails, {
    account: graphql`
        fragment AccountReadonlyContactDetails_account on Account {
            driverLicence
            dateOfBirth
            phoneNumbers {
                id
                type
                number
            }
        }`,
});
